import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Select,
	MenuItem,
	Grid,
	FormControl,
	Stack,
} from '@mui/material';

import { useCallback, useEffect, useState } from 'react';

import GroupEndDate from './GroupEndDate';

import styles from './UserManagement.module.scss';

const { lightBackgroundColor, borderBlack, whiteBackground } = styles;

interface IGroupRolesListProps {
	data: any[];
	handleDateChange: (e: string, data: any) => void;
	testId: string;
}

const GroupRolesList = (props: IGroupRolesListProps) => {
	const { data, handleDateChange, testId } = props;
	const [selectedRoles, setSelectedRoles] = useState<string | any[]>([]);

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 200,
			},
		},
	};

	useEffect(() => {
		setSelectedRoles([]);
		const allRoles: any[] = [];
		data.forEach((ele: any) => {
			const roles = ele?.roles;
			roles.forEach((role: any) => {
				allRoles.push(role?.roleName);
			});
		});
		setSelectedRoles([...allRoles]);
	}, [data]);

	/**
	 * @param data date string,role details
	 * will set the end date to the roles array
	 */
	const handleGropuDateChange = useCallback((val: string, data: any) => {
		data.endDate = val;
		handleDateChange(val, data);
	}, []);

	return (
		<div>
			{data && data.length > 0 ? (
				<Stack sx={{ marginTop: 5 }}>
					<Grid item xs={12}>
						<div className={styles['role-table-main']}>
							<Table stickyHeader>
								<TableHead>
									<TableRow
										sx={{ border: 0, boxShadow: 'none' }}
										key="table-headers"
									>
										<TableCell className={styles['role-table-heading']}>
											Group
										</TableCell>
										<TableCell className={styles['role-table-heading']}>
											Role
										</TableCell>
										<TableCell className={styles['role-table-heading']}>
											End Date
											<span className={styles['opt-font-style']}> (opt)</span>
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{data && data.length > 0
										? data.map((ele: any) => (
												<TableRow
													data-testid={testId}
													key={ele?.groupId}
													sx={{
														width: '100%',
														backgroundColor: lightBackgroundColor,
														borderBottom: `1px solid ${borderBlack}`,
													}}
												>
													<TableCell className={styles['role-table-data']}>
														<div className={styles['group-info-style']}>
															<div className={styles['group-info-title-style']}>
																{ele?.groupName}
															</div>
															<div
																className={styles['group-info-subtitle-style']}
															>
																{ele?.groupDesc}
															</div>
														</div>
													</TableCell>
													<TableCell className={styles['role-table-data']}>
														<FormControl
															sx={{
																m: 1,
																width: 190,
																backgroundColor: whiteBackground,
															}}
														>
															<Select
																labelId="demo-multiple-name-label"
																id="demo-multiple-name"
																value={selectedRoles}
																multiple
																defaultValue=""
																IconComponent={ExpandMoreRoundedIcon}
																MenuProps={MenuProps}
															>
																{ele?.roles.map((role: any) => (
																	<MenuItem
																		className={styles['select-roles']}
																		key={role?.roleId}
																		value={role?.roleName}
																		disabled
																	>
																		{role?.roleName}
																	</MenuItem>
																))}
															</Select>
														</FormControl>
													</TableCell>
													<TableCell className={styles['role-table-data']}>
														<div className={styles['role-table-date']}>
															<GroupEndDate
																data={ele}
																handleGropuDateChange={handleGropuDateChange}
															/>
														</div>
													</TableCell>
												</TableRow>
										  ))
										: null}
								</TableBody>
							</Table>
						</div>
					</Grid>
				</Stack>
			) : null}
		</div>
	);
};

export default GroupRolesList;
